import React, { ReactNode, useState } from 'react';

import NextImage, { ImageProps } from 'next/image';
import { twMerge } from 'tailwind-merge';

import { NextImagePlaceholder } from './NextImagePlaceholder';

export interface IImageProps extends ImageProps {
  wrapperClassName?: string;
  imageClassName?: string;
  showPlaceholder?: boolean;
  customPlaceholderClassName?: string;
  customPlaceholderIcon?: ReactNode;
}

export const NextImageWrapper = ({
  imageClassName,
  wrapperClassName,
  customPlaceholderClassName,
  customPlaceholderIcon,
  showPlaceholder = true,
  ...props
}: IImageProps) => {
  const [hasImageLoaded, setHasImageLoaded] = useState(false);
  const { src } = props;
  return (
    <div className={twMerge(`relative`, wrapperClassName)}>
      {showPlaceholder && (!hasImageLoaded || src === '') && (
        <NextImagePlaceholder
          placeholderIcon={customPlaceholderIcon}
          className={customPlaceholderClassName}
        />
      )}
      {src && src !== '' && (
        <NextImage
          className={twMerge(`object-cover`, imageClassName)}
          onLoad={event => {
            if (props.onLoad) {
              props.onLoad(event);
            }
            setHasImageLoaded(true);
          }}
          onError={event => {
            if (props.onError) {
              props.onError(event);
            }
            setHasImageLoaded(false);
          }}
          {...props}
        />
      )}
    </div>
  );
};
